import React from "react";

// p tag for word count only read only by Screen Readers, SEO purpose */
const ScreenReaderOnly = ({ content }) => {
  return <p className="sr-only">{content || ""}</p>;
};

export default ScreenReaderOnly;
